
import { clone } from "lodash";
import { mapState, mapActions, mapMutations } from "vuex";
import notificationBannerItem from "./notification-banner-item.vue";
export default {
  components: { notificationBannerItem },
  data() {
    return {
      loading: [],
      showTypeForm: false
    };
  },
  computed: {
    ...mapState("restaurant", ["locationDetails", "notifications"])
  },
  beforeMount() {
    this.loading.length = this.notifications.length;
  },
  methods: {
    ...mapActions("restaurant", [
      "getSurveyStatus",
      "submitSurvey",
      "getNotifications",
      "updateNotifications",
      "getLocationDetails"
    ]),
    ...mapActions("reciever", ["patchChannelState"]),
    ...mapMutations("restaurant", ["SET_NOTIFICATIONS"]),
    async handleCTA(notification, index) {
      this.loading[index] = true;
      try {
        if (notification.event === this.$constants.NotificationEvents.STORE_DISABLED) {
          const brandId = this.locationDetails.restaurants.find((el) =>
            el.restaurant_platforms.find(
              (pl) => pl.id === notification.notification_attributes.platform_id
            )
          )?.id;
          const response = await this.patchChannelState({
            restaurantId: brandId,
            id: notification.notification_attributes.platform_id,
            payload: { new_state: "online" }
          });
          await this.updateNotifications({
            id: notification.id,
            payload: { read_via: "cta" }
          });
          await this.sleep(5000);
          await this.getLocationDetails(false);
          this.$nuxt.$emit("show-toast", {
            text: response?.data?.message,
            color: "success darken-2",
            icon: "done",
            flat: true
          });
          this.getNotifications();
        }
      } catch (error) {
        this.$nuxt.$emit("show-error-toast", error);
      }

      this.loading[index] = true;
    },
    async handleClose(notification, index) {
      let newNotifications = clone(this.notifications);
      newNotifications.splice(index, 1);
      this.SET_NOTIFICATIONS(newNotifications);
      try {
        await this.updateNotifications({
          id: notification.id,
          payload: { read_via: "close" }
        });
        await this.sleep(1000);
        this.getNotifications();
      } catch (err) {
        this.$nuxt.$emit("show-error-toast", err);
      }
    },
    async handleTypeFormSurvey() {
      this.showTypeForm = true;
      await this.sleep(500);
      createWidget(FORM_ID, {
        container: document.querySelector("#type-form-container"),
        onSubmit: () => {
          this.handleSurveySubmission();
        }
      });
    },
    handleSurveySubmission() {
      this.loading = true;
      let payload = {
        location_id: this.locationDetails.id ? this.locationDetails.id : "",
        status: "completed",
        name: FORM_ID
      };
      this.submitSurvey(payload)
        .then((response) => {
          this.$nuxt.$emit("show-toast", {
            text: response.data.messages || response.data.message,
            color: "success darken-2",
            icon: "done",
            flat: true
          });
          this.showTypeForm = false;
        })
        .catch((errr) => {
          this.$nuxt.$emit("show-error-toast", errr);
        })
        .finally(() => {
          this.loading = false;
        });
    }
  }
};
